import { components } from '@wsb/guac-widget-core';

const { CTAButton } = components;

export default CTAButton;
